import styled from 'styled-components';

export const ErrorMessage = styled.p`
  margin-top: 6px;

  font-size: 12px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.danger};
`;
